import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shell, Card } from "../components/Layout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PasswordInput } from "../components/PasswordInput";
import { useAuth } from "../context/AuthContext";
import { apiError, http } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [mode, setMode] = useState("login");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const data = await login(email, password);
      navigate(data.role === "admin" ? "/admin" : "/perfil");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const forgot = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Shell title="Acceso a mi cuenta" subtitle="Utilice el mismo usuario y contraseña para el Centro de Estudios y para Logopedia." testid="login-page">
      <Card className="max-w-xl">
        {mode === "login" ? (
          <form onSubmit={submit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="text-lg">Correo electrónico</Label>
              <Input id="email" data-testid="login-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="mt-2 h-14 text-lg" />
            </div>
            <div>
              <Label htmlFor="password" className="text-lg">Contraseña</Label>
              <PasswordInput id="password" testid="login-password-input" required
                autoComplete="current-password" value={password}
                onChange={(e) => setPassword(e.target.value)} className="mt-2 h-14 text-lg" />
              <p className="mt-2 text-sm text-ink-700">
                Pulse el ojo para ver la contraseña y comprobar que está bien escrita.
              </p>
            </div>
            {error && (
              <p data-testid="login-error" className="rounded-lg bg-red-50 p-4 text-base text-red-700">{error}</p>
            )}
            <Button data-testid="login-submit-btn" disabled={busy} className="h-14 w-full text-lg">
              {busy ? "Accediendo..." : "Acceder"}
            </Button>
            <div className="flex flex-col gap-3 pt-2 text-base">
              <button type="button" data-testid="forgot-password-link" className="underline text-left"
                onClick={() => setMode("forgot")}>
                He olvidado mi contraseña
              </button>
              <button type="button" data-testid="go-register-link" className="underline text-left"
                onClick={() => navigate("/centro/matricula")}>
                Aún no dispongo de cuenta: deseo matricular a un alumno
              </button>
            </div>
          </form>
        ) : (
          <form onSubmit={forgot} className="space-y-6">
            <p className="text-lg text-ink-700">
              Indique su correo electrónico y le enviaremos las instrucciones para establecer una
              contraseña nueva.
            </p>
            <div>
              <Label htmlFor="femail" className="text-lg">Correo electrónico</Label>
              <Input id="femail" data-testid="forgot-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="mt-2 h-14 text-lg" />
            </div>
            {sent && (
              <p data-testid="forgot-success" className="rounded-lg bg-logo-light p-4 text-base text-logo-text">
                Solicitud registrada. Si el correo consta en nuestros registros, recibirá las
                instrucciones en unos minutos.
              </p>
            )}
            <Button data-testid="forgot-submit-btn" disabled={busy} className="h-14 w-full text-lg">
              Enviar instrucciones
            </Button>
            <button type="button" className="underline text-base" onClick={() => setMode("login")}>
              Volver al acceso con contraseña
            </button>
          </form>
        )}
      </Card>
    </Shell>
  );
}
